import React from 'react'
import tankImage from "../../../images/products/G.png"
import HeaderTopS3 from '../../../components/HeaderTopS3/HeaderTopS3'
import NavbarS3 from '../../../components/NavbarS3/NavbarS3'
import Logo from '../../../images/snbs_logo1.png'
import PageTitle from '../../../components/pagetitle/PageTitle'
import Footer from '../../../components/footer/Footer'
import Img from '../../../images/home/p-7.jpg'

function TankLayer6() {

   const values = [
    {
      number: 1,
      text: "Long lasting – Built with durable materials to ensure years of reliable use.",
    },
    {
      number: 2,
      text: "Leakproof – Designed to prevent any water leakage for complete peace of mind.",
    },
    {
      number: 3,
      text: "Lightweight – Easy to transport and install without heavy equipment.",
    },
    {
      number: 4,
      text: "Easy to install – User-friendly design that supports quick and hassle-free setup.",
    },
    {
      number: 5,
      text: "6 layers – Multiple protective layers for extra strength and temperature control.",
    },
    {
      number: 6,
      text: "Affordable – Quality you can trust at a price that fits your budget.",
    },
      {
      number: 7,
      text: "Available in various colors – Choose from a range of colors to suit your space.",
    },
      {
      number: 8,
      text: "Resistant to bacterial growth – Maintains water hygiene with anti-bacterial inner layer.",
    },
  ];

  return (
    <>
     <HeaderTopS3 />
     <NavbarS3 hclass={'wpo-site-header wpo-header-style-3'} Logo={Logo} />
      <PageTitle pageTitle={'6 Layer Loft Water Tank'} pagesub={'Water Tank'} Img={Img} />
      <section className="container pt-100">
      <div className="row align-items-center">
        {/* Left Column - Text */}
        <div className="col-lg-6 col-md-12 col-sm-12 text-center">
          <img
            src={tankImage}
            alt="Water Tank" />
        </div>

        {/* Right Column - Image */}
        <div className="col-lg-6 col-md-12 col-sm-12 mb-4">
  <h2 className="fw-bold mb-3">6 Layer Loft Tanks. Compact & Reliable.</h2>
  <p style={{ textAlign: "justify" }}>
    Designed for indoor placement, especially in kitchens or loft spaces, 6-layer loft water tanks are an efficient solution for safe and hygienic water storage. These tanks are perfect where vertical height is limited but water quality cannot be compromised.
  </p>
  <p style={{ textAlign: "justify" }}>
    At SNBS, we offer 6-layer loft water tanks made from 100% virgin, food-grade plastic. Each layer serves a unique purpose—protecting against UV rays, reducing heat, preventing algae formation, and maintaining water purity. Their flat design ensures they fit snugly in tight or overhead spaces.
  </p>
  <p style={{ textAlign: "justify" }}>
    Available in capacities like 300L, 400L, 500L, 750L, and 1000L, our loft tanks are durable, leakproof, easy to clean, and built to last. Whether for domestic use or internal backup storage, these tanks offer space-saving design with dependable performance.
  </p>
</div>

      </div>
    </section>
 <div className="container pt-100 pb-100">
      <h2 className="text-center fw-bold mb-4">6 Layer Loft Water Tank</h2>
      <div className="table-responsive">
        <table className="table table-bordered text-center mb-4">
          <thead className="table-primary">
            <tr>
              <th colSpan="5" className="bg-primary text-white">
                Water tanks available in various liters
              </th>
            </tr>
            <tr>
              <th>Liter</th>
              <th>3000</th>
              <th>5000</th>
              <th>7500</th>
              <th>10000</th>
            </tr>
          </thead>
        </table>

        <table className="table table-bordered text-center">
          <thead className="table-primary">
            <tr>
              <th colSpan="6" className="bg-primary text-white">
                6 Layer Loft Water Tank Size Chart
              </th>
            </tr>
          </thead>
          <tbody>
            <tr className="table-light">
              <th>Size</th>
              <th>300</th>
              <th>400</th>
              <th>500</th>
              <th>750</th>
              <th>1000</th>
            </tr>
            <tr className="table-light">
              <th>Height</th>
              <td>12"</td>
              <td>13"</td>
              <td>17"</td>
              <td>18"</td>
              <td>23"</td>
            </tr>
            <tr className="table-light">
              <th>Diameter</th>
              <td>40"</td>
              <td>42"</td>
              <td>43"</td>
              <td>49"</td>
              <td>51"</td>
            </tr>
             <tr className="table-light">
              <th>Length</th>
              <td>49"</td>
              <td>52"</td>
              <td>58"</td>
              <td>67"</td>
              <td>70"</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
<section style={{backgroundColor:"#f3f3f6"}}>
   <div className="container pt-100 pb-100" >
      <h2 className="text-center fw-bold mb-4">Product Features</h2>
      <div className="row">
        {values.map((item, index) => (
          <div key={index} className="col-md-6 mb-4 d-flex">
            <div
              className="rounded-circle bg-dark text-white d-flex align-items-center justify-content-center me-3"
              style={{ width: "40px", height: "40px", flexShrink: 0 }}>
              {item.number}
            </div>
            <p className="mb-2">{item.text}</p>
          </div>
        ))}
      </div>
    </div>
 </section>
    <Footer hclass={'wpo-site-footer mt-0'} upperContactArea={true} />
    </>
  )
}

export default TankLayer6